const videos = document.querySelectorAll('.videos-section-c .swiper-slide');
const videoWrapperContent = document.querySelector('.video-wrapper-js .video-content');
const videoWrapperCloseButton = document.querySelector('.video-wrapper-js .video-close-button');

videos.forEach(video => {
  video.addEventListener('click', () => {
    const videoAction = video.querySelector('.video-actions');
    document.body.classList.add('show-video-wrapper');
    videoWrapperContent.innerHTML = videoAction.dataset.video;
  })
});

videoWrapperCloseButton.addEventListener('click', () => {
  document.body.classList.remove('show-video-wrapper');
  videoWrapperContent.innerHTML = ''
})

document.body.addEventListener('click', (e) => {
  if (e.target.classList.contains('video-wrapper-js') || e.target.classList.contains('video-content-wrapper-js')) {
    videoWrapperCloseButton.click();
  }
})

document.addEventListener('DOMContentLoaded', function () {
  var videoElements = document.querySelectorAll('video');

  videoElements.forEach(function (videoElement) {
    videoElement.controls = false;

    videoElement.addEventListener('play', function () {
      this.controls = false;
    });

    videoElement.addEventListener('pause', function () {
      this.controls = false;
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  var okendoSnippet = document.querySelector('.reviews-block .okendo-snippet');
  var numberSpan = document.querySelector('.reviews-block .average-rating-number');
  if (okendoSnippet && numberSpan) {
    // Try to find a number like 4.4 or 5.0 in the snippet's text
    var match = okendoSnippet.textContent.match(/([0-5](?:\.[0-9])?)/);
    if (match) {
      numberSpan.textContent = match[1];
    }
  }
});